'use strict';

angular.module('ecrd.states')
    .component('lockInfo', {
        templateUrl: 'modules/states/components/lock-info/template.html',
        controller: 'LockInfoController',
        bindings: {
            formId: '<', // ID del formulario, si hay; si no es un estado global
            listIndices: '<', // índices del formulario
        },
    });
